module.exports = __webpack_public_path__ + "static/media/goLiveApi.d1d22572.png";